module.exports = __webpack_public_path__ + "static/img/markus-spiske-wL7pwimB78Q-unsplash_thumb.3e746c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/markus-spiske-wL7pwimB78Q-unsplash_thumb.png
// module id = RjG7
// module chunks = 4